import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { ROTypography } from "../../components/ROTypography";

import { UFLogo } from "../../assets";

import { FOOTER_LINKS, SOCIAL_MEDIA_LINKS } from "./Footer.constants";

import "./Footer.scss";

const FooterLink = ({ href, text, noreferrer, dataTestId }) => (
  <>
    <a
      href={href}
      data-test-id={dataTestId}
      className="footer-link"
      target="__blank"
      rel={`noopener${noreferrer ? " noreferrer" : ""}`}
    >
      {text}
    </a>
  </>
);

const Footer = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const appVersion = useSelector(
    (state) => state.userInfo?.data?.applicationVersion || "1.0.0"
  );
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <>
      <div id="footer-container" className="footer-wrapper">
        <div className="app-max-width d-flex mx-auto">
          <div className="footer-left-content">
            <div className="footer-links-wrapper">
              {FOOTER_LINKS(t, language).map((link, index) => (
                <React.Fragment key={index}>
                  <FooterLink href={link.href} text={link.text} />
                  <div className="vertical-line"></div>
                </React.Fragment>
              ))}
              {/* uncomment to add cookie preferences */}
              {/* <a id="teconsent"></a> */}
            </div>
            <ROTypography
              className="copy-right-text"
              text={t("footer.footerCopyright", { currentYear: currentYear })}
            />
            <div className="social-icons">
              {SOCIAL_MEDIA_LINKS.map((social, index) => (
                <FooterLink
                  dataTestId={social.id}
                  key={index}
                  href={social.href}
                  text={<social.Icon />}
                  noreferrer
                />
              ))}
            </div>
          </div>
          <div className="footer-right-content">
            <div className="text-end">
              <ROTypography
                className="wave-engine-text"
                asElement="h6"
                text={t("footer.ultrafiltrationOpsAdvisor")}
              />
              <ROTypography
                className="dupont-solutions-text"
                text={t("footer.dupontWaterSolutions")}
              />
              {appVersion && (
                <ROTypography
                  className="version-text"
                  text={t("footer.version") + appVersion}
                />
              )}
            </div>
            <div>
              <img src={UFLogo} alt="UFLogo" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
